import {Component, Input, Output, EventEmitter, ElementRef, HostListener, signal} from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule  } from '@angular/forms';
import { SubOption   } from '../../core/menu.service';

@Component({
  standalone: true,
  selector  : 'app-sub-selector',
  imports   : [CommonModule, FormsModule],
  template  : `
    <button class="fake-select" (click)="toggle()" [class.open]="open()">
      <span class="truncate">{{ selected?.name || 'Selecciona...' }}</span>
      <svg class="caret" width="18" height="18" viewBox="0 0 24 24">
        <path fill="currentColor" d="M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6z"
        />
      </svg>
    </button>

    <ul class="fake-options" *ngIf="open()">
      <li *ngFor="let opt of options"
          [class.active]="opt === selected"
          (click)="select(opt)">
        {{ opt.name }}
      </li>
    </ul>
  `,
  styleUrls: ['./selector.component.scss']
})
export class SubSelectorComponent {
  @Input()  options : SubOption[] = [];
  @Input()  selected?: SubOption;
  @Output() selectionChange = new EventEmitter<SubOption>();

  open = signal(false);

  constructor(private elementRef: ElementRef) {}

  /**
   * Close the dropdown if a click occurs outside the component
   */
  @HostListener('document:click', ['$event.target'])
  public onClick(target: HTMLElement) {
    if (!this.elementRef.nativeElement.contains(target)) {
      this.open.set(false);
    }
  }

  toggle(): void {
    this.open.update(open => !open);
  }

  select(opt: SubOption) {
    this.selected = opt;
    this.selectionChange.emit(opt);
    this.open.set(false);
  }

  change(route: string) {
    const sel = this.options.find(o => o.route === route)!;
    this.selectionChange.emit(sel);
  }
}
